import React from 'react';

import OBNDBNBizBasicInfoComponent from './obn-agent-basic-info.component';
import OBNDBNBizKeyInfoComponent from './obn-agent-key.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';

export const OBNDBNBizComponent = ({openNetworkRegistries,agentNetTypes,
  dbnpregistries, oBNDBNBizsList, deliveryPreference, accountType, deleteKeys, onFormItemChange, keys,
  onFormChange, obnDBNBiz, fetchAcount, accounts, shippingProviders, id, selectedOBNDBNBiz, shippingTypes, back,
  handleFormSubmit, shippingOptionList
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: `OBN Biz - Basic Details`,
      component: <OBNDBNBizBasicInfoComponent
        id={id}
        selectedOBNDBNBiz={selectedOBNDBNBiz}
        shippingTypes={shippingTypes}
        shippingProviders={shippingProviders}
        deliveryPreference={deliveryPreference}
        onFormChange={onFormChange}
        shippingOptionList={shippingOptionList}
        oBNDBNBizsList={oBNDBNBizsList}
        openNetworkRegistries={openNetworkRegistries}
        agentNetTypes={agentNetTypes}
              obnDBNBiz={obnDBNBiz}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Key Details',
      component: <OBNDBNBizKeyInfoComponent
        keys={keys}
        onFormItemChange={onFormItemChange}
        deleteKeys={deleteKeys}
      />,
      isVisible: true,
    },
  
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
      
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            onClick={handleFormSubmit}
            type="submit"
          >
            Save
          </button>
        
      </div>
    </div>
  )
}
export default OBNDBNBizComponent;
